import { BgProvider, Link, Skeleton } from '@backstage/ui';

import { AppIcon } from './AppIcon';
import { RadixApp } from '../../types/radixApp';

import styles from './RadixAppTile.module.css';

type RadixAppTileProps = {
  app: RadixApp;
};

export const RadixAppTile = ({ app }: RadixAppTileProps) => (
  <Link href={app.consoleUrl} target="_blank" rel="noreferrer" className={styles.tile}>
    <AppIcon appName={app.name} />
    <div className={styles.tileContent}>
      <span className={styles.appName}>{app.name}</span>
      <span className={styles.cluster}>{app.clusterLabel}</span>
    </div>
  </Link>
);

// BgProvider tells Skeleton it sits on a neutral-2 surface, so it renders in a
// contrasting neutral-3 — otherwise it matches the tile and its pulse is invisible.
export const RadixAppTileSkeleton = () => (
  <BgProvider bg="neutral-2">
    <div className={styles.skeletonTile}>
      <Skeleton width={40} height={40} rounded />
      <div className={styles.skeletonText}>
        <Skeleton width="70%" height={16} />
        <Skeleton width="45%" height={12} />
      </div>
    </div>
  </BgProvider>
);
